/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Eine Route suchen`
};

const en_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Search for an itinerary`
};

const es_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar itinerario`
};

const fr_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Rechercher un itinéraire`
};

const it_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Cerca un itinerario`
};

const nl_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Een route zoeken`
};

const pt_itinerary__recompute = /** @type {(inputs: {}) => string} */ () => {
	return `Procurar um itinerário`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__recompute = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__recompute(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__recompute", locale)
	if (locale === "de") return de_itinerary__recompute(inputs)
	if (locale === "en") return en_itinerary__recompute(inputs)
	if (locale === "es") return es_itinerary__recompute(inputs)
	if (locale === "fr") return fr_itinerary__recompute(inputs)
	if (locale === "it") return it_itinerary__recompute(inputs)
	if (locale === "nl") return nl_itinerary__recompute(inputs)
	return pt_itinerary__recompute(inputs)
};